import type { AnalyticsEvent, AnalyticsPort } from './analytics.port';

/**
 * No-op adapter — safe default until a provider is chosen.
 * Events are silently dropped in dev and prod.
 */
export class NoopAnalyticsAdapter implements AnalyticsPort {
  track(_event: AnalyticsEvent): void {
    // No-op
  }
}
